export const 홈택스아이디비번찾기주소 = 'https://mob.hometax.go.kr/jsonAction.do?actionId=UTBMPABA05F001';
export const 홈택스아이디생성주소 = 'https://mob.hometax.go.kr/jsonAction.do?actionId=UTBMPABA01F001';
export const 홈택스로그인주소 = 'https://mob.hometax.go.kr/jsonAction.do?actionId=UTBMPBAC01F001';

export const 경정청구서비스공유주소 = 'https://bit.ly/3NPYZIL'; // UTM 있음
export const 경정청구서비스공유주소2 = 'https://bznav.com/tax/refund/';
export const 비즈넵환급서비스공유주소 = 'https://ab.bznav.com/agogeu';

export const 홈택스공동인증서등록가이드주소 =
  'https://help.bznav.com/hc/ko/articles/900006656646-%ED%99%88%ED%83%9D%EC%8A%A4-%EA%B3%B5%EB%8F%99%EC%9D%B8%EC%A6%9D%EC%84%9C-%EB%93%B1%EB%A1%9D';
export const 네이버앱인증서설치안내링크 =
  'https://help.bznav.com/hc/ko/articles/27375320955161--%EC%A7%84%ED%96%89%EB%B0%A9%EB[…]%A1%B0%ED%9A%8C-%EA%B0%9C%EC%9D%B8%EC%82%AC%EC%97%85%EC%9E%90';

export const 네이버스마트플레이스주소 = 'https://new.smartplace.naver.com';

export const 네이버커머스솔루션마켓주소 = 'https://solution.smartstore.naver.com/ko/home';

export const 비즈넵경정청구랜딩주소 = 'https://bznav.com/tax/refund';

export const 비즈넵케어신청완료링크 = 'https://ac.bznav.com/zvrx2t';
export const 비즈넵케어조회완료링크 = 'https://ac.bznav.com/vztkf4';
export const 비즈넵케어결제완료링크 = 'https://ac.bznav.com/bwducm';
export const 비즈넵케어환급홈링크 = 'https://ac.bznav.com/mycpm5';

export const INVITE_PROMOTION_PATH = '/home/event/share';

export const SUPPORT_BOT_LINK = {
  default: 'https://bznav.channel.io/support-bots/44879',
  home: 'https://bznav.channel.io/home',
  errors: 'https://bznav.channel.io/support-bots/101732',
  개인법인선택: 'https://bznav.channel.io/support-bots/102061',
  인증타입선택: 'https://bznav.channel.io/support-bots/102163',
  인증정보입력: 'https://bznav.channel.io/support-bots/102319',
  조회완료: {
    일반: 'https://bznav.channel.io/support-bots/102251',
    VIP개인: 'https://bznav.channel.io/support-bots/104364',
    VIP법인: 'https://bznav.channel.io/support-bots/68339'
  },
  신청완료: 'https://bznav.channel.io/support-bots/102259',
  조회목록: 'https://bznav.channel.io/support-bots/102275',
  환급결정확인: 'https://bznav.channel.io/support-bots/102514',
  신청결과: {
    신청완료: 'https://bznav.channel.io/support-bots/102516',
    환급불가: 'https://bznav.channel.io/support-bots/101616',
    신고완료: 'https://bznav.channel.io/support-bots/101639',
    환급결정: 'https://bznav.channel.io/support-bots/101663',
    결제완료: 'https://bznav.channel.io/support-bots/101698',
    환급완료: 'https://bznav.channel.io/support-bots/102652'
  },
  양도세환급랜딩: 'https://bznav.channel.io/workflows/44879'
};
export const NPS_GOOGLE_FORM_LINK = {
  조회완료: 'https://forms.gle/wJHfUwKq2wyt71de9',
  신청완료: 'https://forms.gle/EwVCTmVoKcw38NMd6',
  환급결정: 'https://forms.gle/ca6Rb9JRYaMUoogU8',
  환급완료: 'https://forms.gle/auhm9HtvEUSu3aaJ9',
  결제완료: 'https://forms.gle/Jz9Prp7tN4wY1wNWA',
  default: 'https://forms.gle/wt22CYfgxoY9pXPi9'
};
